import { Maybe, Optional } from '@vimeo/core/types/generic';

/**
 * @param uri - optional URI string to parse
 * @returns ID by mask from URI string
 */
export function parseLastIdFromUri(uri?: Maybe<string>): Optional<number> {
  if (!uri) {
    return null;
  }

  const id: number = Number.parseInt(String(uri.match(new RegExp('(\\d+)/?$'))?.[0]));

  return Number.isNaN(id) ? null : id;
}

/**
 * Get UUID by mask from URI string.
 */
export function getUuidFromUri(uri?: string): Maybe<string> {
  return /((\w{4,12}-?)){5}/.exec(uri || '')?.[0];
}

/**
 * Parse clip id from default URI used in vimeo clip object.
 */
export function parseClipIdFromURI(uri: string): Optional<number> {
  const regExp: RegExp = new RegExp('videos/([\\d]+)/?.*');
  const matches: Optional<RegExpMatchArray> = uri.match(regExp);

  return matches ? Number.parseInt(matches[1]) : null;
}

/**
 * Parse user id from default URI used.
 */
export function parseUserIdFromURI(uri: string): number {
  const regExp: RegExp = new RegExp('users/([\\d]+)/?.*');
  return Number.parseInt(uri.match(regExp)![1]);
}

/**
 * Parse event id from default URI used.
 */
export function parseEventIdFromURI(uri: string): number {
  const regExp: RegExp = new RegExp('event/([\\d]+)/?.*');
  return Number.parseInt(uri.match(regExp)![1]);
}
